import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyInsuranceEligibilityFeatureCallout = lazy(
  () => import('./svg-components/insurance-eligibility-feature-callout')
);

const InsuranceEligibilityFeatureCallout = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyInsuranceEligibilityFeatureCallout {...rest} />
  </Suspense>
);

export default InsuranceEligibilityFeatureCallout;
